import styled from "styled-components";

export const Wrapper = styled.div`
  .login-form {
    width: 500px;
    margin: auto;
  }
  @media screen and (max-width: 700px) {
    .login-form {
      width: 90%;
    }
  }
`;
